<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formFotoProducto" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md12>
              <v-select
                v-model="fotoProducto.colorId"
                :items="colores"
                item-text="nombre"
                item-value="colorId"
                label="Color"
                :loading="loadingColores"
                placeholder="Color"
                single-line
                :rules="[
                  () => !!fotoProducto.colorId || 'El campo es requerido',
                ]"
                required
                :readonly="readOnly"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <!-- <img :src="fotoProducto.UrlFotoThumb" height="200" v-if="fotoProducto.UrlFotoThumb"/> -->
              <v-text-field
                label="Selecciona una imagen"
                @click="openFileDialog"
                v-model="imageName"
                prepend-icon="attach_file"
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="fotoProductoInput"
                accept="image/*"
                @change="onFileImageChanged"
              />
            </v-flex>
            <v-flex xs12 sm12 md12>
              <img
                :src="fotoProducto.urlFotoThumb"
                height="200"
                class="mx-auto d-block"
              />
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveFotoProducto"
          >Guardar</v-btn
        >
      </v-card-actions>

      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Foto de producto guardada con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <snack-bar></snack-bar>
  </v-dialog>
</template>

<script>
import snackBar from "@/components/SnackBar";
import colorService from "@/services/colorService";
import fotoProductoService from "@/services/fotoProductoService";

export default {
  components: {
    snackBar,
  },
  props: {
    fotoProducto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      loadingColores: false,
      colores: [],
      imageName: "",
      imageUrl: "",
      imageFile: "",
      nuevaFoto: true,
      readOnly: false,
    };
  },
  mounted() {
    this.extraerColores();
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },

    setUpdateFoto(esActualizacion) {
      if (esActualizacion) {
        this.readOnly = true;
        this.nuevaFoto = false;
      } else {
        this.readOnly = false;
        this.nuevaFoto = true;
      }
    },
    extraerColores() {
      let self = this;
      self.loadingColores = true;

      colorService
        .getAll()
        .then((result) => {
          self.colores = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingColores = false;
        });
    },
    openFileDialog() {
      this.$refs.fotoProductoInput.click();
    },
    onFileImageChanged(e) {
      let self = this;
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          self.fotoProducto.urlFotoThumb = fr.result;
          self.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    saveFotoProducto() {
      let self = this;

      if (self.$refs.formFotoProducto.validate()) {
        self.operationStart();

        if (self.nuevaFoto) {
          self.addFotoProducto();
        } else {
          self.updateFotoProducto();
        }
      }
    },
    addFotoProducto() {
      let self = this;

      fotoProductoService
        .add(self.fotoProducto, self.imageFile)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onFotoProductoAdded", result);

          setTimeout(() => {
            self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
            self.$store.state.iconoForm = "/images/general/actualizar-40.png";
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateFotoProducto() {
      let self = this;
      if (self.imageFile) {
        fotoProductoService
          .update(self.fotoProducto, self.imageFile)
          .then((result) => {
            self.operationSuccess();

            //Enviar tipo producto al componente padre
            self.$emit("onFotoProductoUpdated", result);

            setTimeout(() => {
              self.$store.state.tituloForm = "MODIFICAR PRODUCTO";
              self.$store.state.iconoForm = "/images/general/actualizar-40.png";
              self.showDialog = false;
              self.resetForm();
            }, 2000);
          })
          .catch((e) => {
            self.operationFailed(e);
            console.log(e);
          });
      } else {
        self.$store.state.snackbar.color = "error";
        self.$store.state.snackbar.text = "No se ha cargado una imagen nueva!";
        self.$store.state.snackbar.visible = true;
        self.operationReset();
      }
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formFotoProducto.resetValidation();
      self.imageName = "";
      self.imageFile = "";
      self.imageUrl = "";
      self.fotoProducto.colorId = 0;
      self.fotoProducto.urlFotoThumb = null;
    },
  },
};
</script>
